export default __webpack_public_path__ + "static/media/care-seeker-img.ebaf8310.png";